import { defineComponent as _defineComponent } from 'vue'
import { msg_friend_apply_list, msg_friend_list } from "@/network/socket/SocketReq";
import { onMounted, onUnmounted, Ref, ref } from "vue";

import EventBus from "@/uitls/EventBus";
import IMPinyin from "@/uitls/pinyin";
import { IMformatDate, YMPush } from "@/uitls/uitls";
import IMUtils from "@/network/socket/imUtils";
import router from "@/router";
import indexDB from "@/network/db/dexieDb";
import { getIMFriend } from "@/network/db/dbServe";
import { hostRankingList } from "@/api/php/home";
import { useRoute } from "vue-router";
import Platform from "@/config/platform";
import { usePiniaState } from "@/store/userPinia";
import { storeToRefs } from "pinia";
import { serverConfigPiniaState } from "@/store/serverConfig";
import { toDownloadApp } from "@/uitls/native";

export default /*#__PURE__*/_defineComponent({
  name: 'Friend',
  setup(__props, { expose }) {
  expose();

const userStore = usePiniaState();
const ConfigpiniaStore = serverConfigPiniaState();

const { is_lb } = storeToRefs(ConfigpiniaStore);

const { toLogin } = userStore;
const friendList: Ref<any> = ref();
const isfriendList = ref(false);
const th = process.env.VUE_APP_Language as string;
const route = useRoute();
const arterBg = require(`@/assets/${process.env.VUE_APP_NAME}/download.png`)
const arterBtn = require(`@/assets/${process.env.VUE_APP_NAME}/download_btn.png`)
const zbtype = require(`@/assets/${process.env.VUE_APP_NAME}/zbtype.png`)
const offArterBtn = require("@/assets/images/guanbi.png")
onMounted(() => {
  toLogin();
  msg_friend_list();
  msg_friend_apply_list();
  getData();
  YMPush('MAIN', 'ChatPage')
  let { webclip } = route.query;
  if (webclip) {
    isWebclip.value = true;
  } else {
    isWebclip.value = false;
  }

});
const hotzb = ref([])
//获取明星主播的数据
const getHostRankingList = async () => {
  const res: any = await hostRankingList({
    type: 2
  });
  if (res && res.code == 200) {
    hotzb.value = res.data;
  }
}

onUnmounted(() => {
  EventBus.off("myfriend");
  EventBus.off("newFriendNum");
  EventBus.off("newFriend");
  EventBus.off("dbOnsuccess");
});
EventBus.on("newFriend", (list: Array<any>) => {
  let tempList = [];
  list.forEach(item => {
    if (item.applyState == 0) {
      tempList.push(item)
    }
  })
  badge.value = tempList.length

});

const badge = ref(0);

EventBus.on("newFriendNum", (num: number) => {
  badge.value = num;
});
EventBus.on("dbOnsuccess", () => {
  getData();
});
const downloadshow = ref(false);
const isWebclip = ref(false)
const showDownApp = () => {
  let { webclip } = route.query;
  if (!webclip) {
    downloadshow.value = true;
  }
};
const open = () => {
  if (Platform.downUrl != "") {
    YMPush("DOWNLOAD", "点击下载")
    toDownloadApp();
  }
};
const getData = async () => {
  //好友列表数据来了，把他形成数据排列好。按abcd排序
  if (!indexDB.open) {
    return;
  }
  const list = await getIMFriend();
  if (list.length > 0) {
    isfriendList.value = true;
  } else {
    getHostRankingList()
  }

  // console.log("imfriend",list);

  let obj = {};
  for (let i = 0; i < list.length; i++) {
    const element = list[i];
    const key = topinyin(element.nickname);
    let templist = [];
    if (!obj[key]) {
      obj[key] = [];
    } else {
      templist = obj[key];
    }
    templist.push(element);
    obj[key] = templist;
  }
  let temp = [];
  for (let k in obj) {
    temp.push({ sort: k, list: obj[k] });
  }
  temp = temp.sort((a, b) => {
    if (a.sort == "#") {
      return 1;
    }
    if (b.sort == "#") {
      return -1;
    }
    return a.sort.charCodeAt(0) - b.sort.charCodeAt(0);
  });
  friendList.value = temp;
  // console.log('friendList.value',friendList.value);

};

EventBus.on("myfriend", (list: any) => {
  getData();
});

const toChat = (data) => {
  let chatkey;
  chatkey = IMUtils.createChatKey(data.uid).toString();
  router.push(`/chat/?id=${chatkey}`);
};
const checkNum = (num) => {
  switch (num) {
    case "":
      return "#";
    case "1":
      return "#";
    case "2":
      return "#";
    case "3":
      return "#";
    case "4":
      return "#";
    case "5":
      return "#";
    case "6":
      return "#";
    case "7":
      return "#";
    case "8":
      return "#";
    case "9":
      return "#";
    case "0":
      return "#";
    default:
      return num;
  }
};

const toNewFriend = () => {
  router.push("/newfriend");
};

const topinyin = (name) => {
  const v = IMPinyin.convertPinyin(name).toUpperCase();

  return checkNum(v[0]);
};

const toGroup = () => {
  router.push("/group");
};

const __returned__ = { userStore, ConfigpiniaStore, is_lb, toLogin, friendList, isfriendList, th, route, arterBg, arterBtn, zbtype, offArterBtn, hotzb, getHostRankingList, badge, downloadshow, isWebclip, showDownApp, open, getData, toChat, checkNum, toNewFriend, topinyin, toGroup, IMformatDate, router }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})